/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Container, Box, Grid } from "@material-ui/core";
import styles from "./styles.module.scss";
import Loading from "../../../../../home/components/Loading";
import InputForm from "../../../../../../components/InputForm";
import FormActions from "../../../../components/FormActions";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import Swal from "sweetalert2";
import store from "../../../../../../store/store";
import {
  identifications,
  labelIdentification,
} from "../../../../../../enum/IdentificationTypes";

export const DocumentCategoryForm = (props) => {
  const labels = ["Sigla *", "Nome *", "Tipo *", "Identificação *"];
  let api = AppAPIService.getInstance();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [categoryTypeOptions, setCategoryTypeOptions] = useState([]);
  const { auth } = store.getState();

  /*name*/
  const [name, setName] = useState("");
  const [nameRole, setNameRole] = useState("");
  const [nameError, setNameError] = useState("");
  const handleInputName = (name) => {
    if (!name) {
      setName();
      setNameError("Campo obrigatório");
      setNameRole("notOk");
    } else {
      setName(name);
      setNameError("");
      setNameRole("ok");
    }
  };
  /* end name*/

  /* category type */
  const [categoryType, setCategoryType] = useState("");
  const [categoryTypeError, setCategoryTypeError] = useState("");
  const [categoryTypeRole, setCategoryTypeRole] = useState("");

  const handleInputCategoryType = (categoryType) => {
    if (!categoryType) {
      setCategoryType();
      setCategoryTypeError("Campo obrigatório");
      setCategoryTypeRole("notOk");
    } else {
      setCategoryType(categoryType);
      setCategoryTypeError("");
      setCategoryTypeRole("ok");
    }
  };

  /* identification type */
  const [identificationType, setIdentificationType] = useState("");
  const [identificationTypeError, setIdentificationTypeError] = useState("");
  const [identificationTypeRole, setIdentificationTypeRole] = useState("");

  const handleInputIdentificationType = (identificationType) => {
    if (!identificationType) {
      setIdentificationType();
      setIdentificationTypeError("Campo obrigatório");
      setIdentificationTypeRole("notOk");
    } else {
      setIdentificationType(identificationType);
      setIdentificationTypeError("");
      setIdentificationTypeRole("ok");
    }
  };

  const getCategoryTypeOptions = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await api.makeHttpRequest({
        url: `/document-category-type/list-paginated`,
        method: "GET",
      });
      const categoryTypes = Array.isArray(response?.data) ? response.data : response || [];
      const categoryTypeOptionsFromApi = categoryTypes.map((categoryType) => {
        return { value: categoryType.id, label: categoryType.name };
      });
      setCategoryTypeOptions(categoryTypeOptionsFromApi);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [api]);

  useEffect(() => {
    getCategoryTypeOptions();
  }, [getCategoryTypeOptions]);
  /* end category type */

  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm =
      name !== "" &&
      nameRole === "ok" &&
      categoryTypeRole === "ok" &&
      categoryType !== "" &&
      identificationType !== "";
    return validForm;
  }, [name, nameRole, categoryType, categoryTypeRole, identificationType]);

  /* end form validation */
  /* submitCreation */
  const showErrorResponse = useCallback((response) => {
    let message = "";
    const duplicateNameMessage =
      "Already exists a document category with this name, please try another one";
    if (response?.message === duplicateNameMessage) {
      message = ", Nome de categoria de documento já cadastrada";
    }

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Erro ao criar categoria de documento" + message + ".",
    });
  });

  const submitCreation = useCallback(
    async (e) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        setIsLoading(true);
        console.log("aqui é criado a categoria");
        const response = await api.makeHttpRequest({
          url: `/document-category`,
          method: "POST",
          data: {
            id: "",
            name,
            active: true,
            documentCategoryTypeId: categoryType.value,
            identificationType: identificationType.value,
          },
        });
        setIsLoading(false);
        if (response.status !== 200 && response.status !== 201) {
          setIsLoading(false);
          showErrorResponse(response);
          return;
        }
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: `Categoria de documento criada com sucesso. nome: ${name}`,
        }).then(() => {
          history.push("/admin/parametrizacao");
        });
      } catch (error) {
        console.error("error: ", error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    },
    [
      history,
      api,
      auth.token,
      auth.user,
      name,
      categoryType,
      identificationType,
      setIsLoading,
      setNameError,
      setNameRole,
    ]
  );
  /* end submitCreation */

  /* submitEdition */
  const submitEdition = useCallback(
    async (e) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        const response = await api.makeHttpRequest({
          url: `/document-category/${props.editingRecord.id}`,
          method: "PATCH",
          data: {
            name,
            active: true,
            documentCategoryTypeId: categoryType.value,
            identificationType: identificationType.value,
          },
        });
        if (response.status !== 200 && response.status !== 201) {
          setIsLoading(false);
          showErrorResponse(response);
          return;
        }
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: `Categoria de documento atualizada com sucesso. nome: ${name}`,
        }).then(() => {
          history.push("/admin/parametrizacao");
        });
      } catch (error) {
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    },
    [
      history,
      api,
      auth.token,
      auth.user,
      name,
      categoryType,
      identificationType,
      setIsLoading,
      setNameError,
      setNameRole,
    ]
  );

  /* clean form */
  const onCleanForm = async () => {
    setName("");
    setCategoryType("");
    setNameError("");
    setNameRole("");
    setCategoryTypeError("");
    setCategoryTypeRole("");
  };
  useEffect(() => {
    if (props?.editingRecord) {
      const { editingRecord } = props;
      handleInputCategoryType({
        value: editingRecord.type.id,
        label: editingRecord.type.name,
      });
      handleInputName(editingRecord.name);

      handleInputIdentificationType({
        value: editingRecord.identificationType,
        label: labelIdentification[editingRecord.identificationType],
      });
    }
  }, [props?.editingRecord]);

  /* end clean form */
  return (
    <Container
      style={{
        display: "block",
        margin: "0",
        padding: "0",
      }}
      maxWidth="xl"
    >
      <Loading isLoading={isLoading} />
      <Container
        style={{
          width: "100%",
          display: "block",
          padding: 0,
          margin: "0 !important",
        }}
        maxWidth="xl"
      >
        <form
          className={styles.form}
          autoComplete="off"
          style={{
            padding: "0 !important",
            margin: "0 !important",
          }}
        >
          <div
            className={styles.containerInputs}
            style={{
              padding: "0 !important",
            }}
          >
            <Grid xl={12} lg={12} md={12} sm={12} xs={12} container style={{}}>
              <Grid
                xl={4}
                lg={4}
                md={4}
                style={{
                  padding: "0 5px 0 0 ",
                }}
              >
                <InputForm
                  type="text"
                  name="name"
                  placeholder="Digite o nome do documento"
                  style={{}}
                  label={labels[1]}
                  value={name}
                  required={true}
                  onChange={handleInputName}
                  error={nameError}
                  role={nameRole}
                />
              </Grid>
              <Grid
                xl={4}
                lg={4}
                md={4}
                style={{
                  padding: "0 5px 0 0 ",
                }}
              >
                <InputForm
                  type="text"
                  name="type"
                  placeholder="Selecione o tipo"
                  label={labels[2]}
                  required={true}
                  isSelect={true}
                  value={categoryType}
                  options={categoryTypeOptions}
                  onChange={handleInputCategoryType}
                  error={categoryTypeError}
                  role={categoryTypeRole}
                />
              </Grid>
              <Grid
                xl={4}
                lg={4}
                md={4}
                style={{
                  padding: "0 5px 0 0 ",
                }}
              >
                <InputForm
                  type="text"
                  name="type"
                  placeholder="Selecione uma identificação"
                  label={labels[3]}
                  required={true}
                  isSelect={true}
                  value={identificationType}
                  options={identifications}
                  onChange={handleInputIdentificationType}
                  error={identificationTypeError}
                  role={identificationTypeRole}
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </Container>
      <FormActions
        module={"parametrizacao"}
        formIsValid={formIsValid()}
        onCleanForm={onCleanForm}
        onSubmit={props?.editingRecord ? submitEdition : submitCreation}
        hideCancel={true}
        messagem
      />
    </Container>
  );
};
export default DocumentCategoryForm;
